import React from 'react';
import BlazeInputDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { MockServiceStatus } from 'types/rest/mockServiceTypes';
import i18n from 'i18n';

export const defaultStatus: BlazeDropdownItem = {
  id: 'ALL',
  name: '- All Statuses -',
};

const mockServicesStatuses: BlazeDropdownItem[] = [
  {
    id: 'RUNNING',
    name: 'Running',
  },
  {
    id: 'STOPPED',
    name: 'Stopped',
  },
  {
    id: 'CONFIGURING',
    name: 'Configuring',
  },
  {
    id: 'FAILED',
    name: 'Failed',
  },
];

type MockServiceStatusFilterProps = {
  /** Currently selected status*/
  status: MockServiceStatus | null;
  /** On Change handler */
  changeStatusHandler: (status: MockServiceStatus | null) => void;
};

const MockServiceStatusFilter = (props: MockServiceStatusFilterProps) => {
  const selectStatusHandler = (statusItem: BlazeDropdownItem) => {
    if (statusItem.id !== 'ALL') {
      props.changeStatusHandler(statusItem.id as any);
    } else {
      props.changeStatusHandler(null);
    }
  };

  /** Translates id of selected status to BlazeDropdownItem */
  const getSelectedItem = () => {
    if (props.status === null) {
      return defaultStatus;
    }
    const status = mockServicesStatuses.find(item => item.id === props.status);
    return status ? status : defaultStatus;
  };

  return (
    <>
      <label className="mr-4" htmlFor="qa-mock-service-status-picker">
        {i18n.t('common:mockServiceFilter.status') + ':'}
      </label>
      <div className="d-inline-block" style={{ minWidth: '200px' }}>
        <BlazeInputDropdown
          id={'qa-mock-service-status-picker'}
          showGroups={false}
          isSearchable={false}
          minDropdownMenuWidth={290}
          maxDropdownHeight={250}
          items={mockServicesStatuses}
          selected={getSelectedItem()}
          onClick={selectStatusHandler}
          isDefaultOptionSelectable={true}
          defaultOption={defaultStatus}
        ></BlazeInputDropdown>
      </div>
    </>
  );
};

export default MockServiceStatusFilter;
